import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class StudentTrainerAssignmentGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Assignment',
      ROUTE_PATH.studentTrainerAssignment,
      '',
      false,
      false,
      8,
      false,
      false,
      ['topic', 'batch', 'category_id', 'mobile_number'],
      false,
      [],
      { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
      false,
      null,
      false,
      false,
      false,
      '',
      { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: true },
      false,
      '',
      null,
      null,
      true,
      true,
      true,
      [],
      false,
      {
        isExtraActions: false,
        btnLabel: '',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: false,
        previewBtnLabel: '',
      },
      {
        isCheckboxEmit: false,
        emitKey: 'id',
        checkedKey: '',
        valueKey: '',
      },
      {
        isDownload: false,
        key: '',
        valueKey: '',
      },
      {
        isTabStatus: false,
        label: '',
        isChecked: false,
      },
      false,
      true,
      {
        isPrimary: true,
        isDanger: false,
      },
      '',
      { value: '', isVisible: false },
      false,
      false,
      false
    );
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const topic = new Headers('Topic', 'topic', false, false, 'text', '0', {
      isColumnNavigation: true,
      navigationUrl: ROUTE_PATH.assignmentEditForm,
      navigateOperationType: OperationType.UPDATE,
      navigateTransferData: new WidgetModel(),
      navigatePageName: 'View Assignment',
    });
    const type = new Headers('Type', 'type_name', false, false, 'text');
    const batch = new Headers(
      'Batch',
      'batch_number',
      false,
      false,
      'text'
    );
    const timeslot = new Headers(
      'Date and Time',
      'date_range',
      false,
      false,
      'text',
      "0",
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
        // navigatePageName: 'Assignment Accepted',
      });

    const invited = new Headers(
      'Invited',
      'invited',
      false,
      false,
      'text',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
        navigatePageName: 'Invited',
      });

    const accepted_student = new Headers(
      'Accepted',
      'attended',
      false,
      false,
      'text',
      "0",
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.assignment_accepted,
        navigateOperationType: OperationType.VIEW,
        navigateTransferData: new GridParams(),
        // navigatePageName: 'Assignment Accepted',
      });



    // const accepted_student = new Headers('Accepted', 'accepted', false, false, 'text', '0', { isColumnNavigation: true, navigationUrl: ROUTE_PATH.assignment_accepted, navigateOperationType: OperationType.VIEW, navigateTransferData: new GridParams() })

    const nonaccepted = new Headers(
      'Non Accepted',
      'non_accepted_student',
      false,
      false,
      'text',
      '0',
      // {
      //   isColumnNavigation: true,
      //   navigationUrl: ROUTE_PATH.assignment_not_accepted,
      //   navigateOperationType: OperationType.VIEW,
      //   navigateTransferData: new GridParams(),
      // }
      );

    const overallFeedback = new Headers(
      'Provide overall Feedback',
      'overall_feedback',
      false,
      false,
      'text',
      '0'

    );

    headers.push(topic);
    headers.push(type);
    headers.push(batch);
    headers.push(timeslot);
    headers.push(invited);
    headers.push(accepted_student);
    headers.push(nonaccepted);
    headers.push(overallFeedback);
    return headers;
  }

  getNavigationGridParam() {
    const param = new GridParams();
    param.pathParam = 'Trainers';
    return param;
  }
}